import { instance } from "@src/service/api";

export const setCookie = () => {
  const token = localStorage.getItem("token") || "";
  instance.get("/v3/cookie-sharing", {
    withCredentials: true,
    params: {
      token,
    },
  });
};
